export { default as AnimatedOverlay } from './animatedOverlay.container';
